module.exports = __webpack_public_path__ + "c32925054f3bcedd8d552cfa3e31b21b.pdf";